// extracted by mini-css-extract-plugin
export var acceptButton = "_32-5";
export var fullContent = "_32-4";
export var link = "_32-6";
export var linkIcon = "_32-7";
export var sideContent = "_32-3";
export var sideImage = "_32-2";
export var sideImageWrapper = "_32-1";
export var splitLayout = "_32-0";